import { render, staticRenderFns } from "./productImageInfo.vue?vue&type=template&id=2cbf718a&scoped=true&"
import script from "./productImageInfo.vue?vue&type=script&lang=js&"
export * from "./productImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./productImageInfo.vue?vue&type=style&index=0&id=2cbf718a&prod&scoped=true&lang=less&"
import style1 from "./productImageInfo.vue?vue&type=style&index=1&id=2cbf718a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf718a",
  null
  
)

export default component.exports